import { createContext, useCallback, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedLabels } from "../../../../redux/Modals/selectors";
import { setSelectedLabels } from "../../../../redux/Modals/actions";

type Action = "SHOW_ALL" | "HIDE_ALL";

type IImageViewContext = {
  hideAllLabels: () => void;
  showAllLabels: () => void;
  labelsGlobalAction: Action;
};

const ImageViewContext = createContext<IImageViewContext>(
  {} as IImageViewContext,
);

export const useImageViewContext = () => useContext(ImageViewContext);

export const ImageViewProvider = ({ children }: any) => {
  const dispatch = useDispatch();
  const [labelsGlobalAction, setLabelsGlobalAction] = useState<
    "SHOW_ALL" | "HIDE_ALL"
  >("SHOW_ALL");
  const selectedLabels = useSelector(getSelectedLabels);

  const updateLabelsSelectedValue = useCallback(
    (selected: boolean) =>
      dispatch(
        setSelectedLabels(selectedLabels.map((l: any) => ({ ...l, selected }))),
      ),
    [dispatch, selectedLabels],
  );

  const hideAllLabels = useCallback(() => {
    setLabelsGlobalAction("HIDE_ALL");
    updateLabelsSelectedValue(false);
  }, [updateLabelsSelectedValue]);
  const showAllLabels = useCallback(() => {
    setLabelsGlobalAction("SHOW_ALL");
    updateLabelsSelectedValue(true);
  }, [updateLabelsSelectedValue]);

  return (
    <ImageViewContext.Provider
      value={{
        hideAllLabels,
        showAllLabels,
        labelsGlobalAction,
      }}
    >
      {children}
    </ImageViewContext.Provider>
  );
};
